const NODE_ENV = process.env.REACT_APP_NODE_ENV;

const getUserKey = () => {
  const isDevelopment = NODE_ENV === 'development';
  if (isDevelopment) {
    return "gleamdesk-admin-dev"
  }

  return "gleamdesk-admin";
}

export default getUserKey;